// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadShipTos from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTos";
import { getShipTosDataView } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import SearchFieldWrapper, { SearchFieldWrapperStyles } from "@steiner/App/Components/OpenBids/SearchFieldWrapper";
import Select, { SelectPresentationProps, SelectProps } from "@steiner/MobiusOverrides/Select/Select";
import React, { FC, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

export interface SearchFieldSelectShipToProps {
    selectProps?: SelectProps;
    extendedStyles?: SearchFieldSelectShipToStyles;
}

export interface SearchFieldSelectShipToStyles {
    searchFieldWrapperStyles?: SearchFieldWrapperStyles;
    select?: SelectPresentationProps;
}

export const searchFieldSelectShipToStyles: SearchFieldSelectShipToStyles = {};

const shipTosParameter: GetShipTosApiParameter = {
    page: 1,
    pageSize: 20,
    expand: ["validation", "excludeOneTime"],
};

const mapStateToProps = (state: ApplicationState) => ({
    shipTosDataView: getShipTosDataView(state, shipTosParameter),
});

const mapDispatchToProps = {
    loadShipTos,
};

export type Props = SearchFieldSelectShipToProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

const SearchFieldSelectShipTo: FC<Props> = React.memo(
    ({ loadShipTos, shipTosDataView, selectProps, extendedStyles }) => {
        const [styles] = React.useState(() => mergeToNew(searchFieldSelectShipToStyles, extendedStyles));

        useEffect(() => {
            if (!shipTosDataView.value && !shipTosDataView.isLoading) {
                loadShipTos(shipTosParameter);
            }
        });
        return (
            <SearchFieldWrapper {...styles.searchFieldWrapperStyles}>
                <Select {...selectProps} {...styles.select}>
                    <option disabled value="-2">
                        {translate("Select an option")}
                    </option>
                    {shipTosDataView.value &&
                        shipTosDataView.value.map(shipTo => (
                            <option key={shipTo.id} value={shipTo.customerSequence}>
                                {shipTo.label}
                            </option>
                        ))}
                </Select>
            </SearchFieldWrapper>
        );
    },
);

export default connect(mapStateToProps, mapDispatchToProps)(SearchFieldSelectShipTo);
